// @ts-nocheck
import React from 'react';
import { useField } from 'formik';
import { useIntl } from 'react-intl';
import { StyledInput } from './styled';

export interface ICurrencyFormattedInputProps {
  id: string;
  invalid: boolean;
  disabled: boolean;
  name: string;
  currency: string;
}

const CurrencyFormattedInput = ({
  id,
  invalid,
  disabled,
  name,
  currency,
}: ICurrencyFormattedInputProps): JSX.Element => {
  const { locale } = useIntl();

  const [, { value: metaValue }, { setValue }] = useField(name);

  return (
    <StyledInput
      intlConfig={{ locale, currency }}
      $isInvalid={invalid}
      disabled={disabled}
      id={id}
      name={name}
      value={metaValue}
      onValueChange={(value) => setValue(value)}
    />
  );
};

export default CurrencyFormattedInput;
